import { useEffect } from "react";

import { useAppSelector } from "@/hooks/redux";
import { darkTheme, lightTheme } from "@/theme";
import { Theme } from "@/types";

const THEME_COLORS = {
    [Theme.DARK]: darkTheme.primaryBackground,
    [Theme.LIGHT]: lightTheme.primaryBackground,
} as const;

export const useThemeColor = () => {
    const type = useAppSelector((s) => s.theme.type);

    useEffect(() => {
        let meta = document.querySelector<HTMLMetaElement>(
            'meta[name="theme-color"]',
        );

        if (!meta) {
            meta = document.createElement("meta");
            meta.name = "theme-color";
            document.head.appendChild(meta);
        }

        meta.content = THEME_COLORS[type];
    }, [type]);
};
